module.exports = __webpack_public_path__ + "img/FooterCpptEseme.ca693c50.png";